export default {
  title: '帧图片选择',
  next: '下一步',
  noSelectTip: '已选满所需帧数，不可再勾选',
  selected: '已选中 {selectNum}/{total}个',
  submit: '完成',
}
